/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
var LOAD = 'baltimorebrew.com/navSpecialSeries/LOAD';
var LOAD_SUCCESS = 'baltimorebrew.com/navSpecialSeries/LOAD_SUCCESS';
var LOAD_FAIL = 'baltimorebrew.com/navSpecialSeries/LOAD_FAIL';

var initialState = {
	loaded: false,
	data: []
};

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	switch (action.type) {
		case LOAD:
			{
				return _extends({}, state, {
					loading: true
				});
			}
		case LOAD_SUCCESS:
			{
				return _extends({}, state, {
					loading: false,
					loaded: true,
					data: action.result,
					error: null
				});
			}
		case LOAD_FAIL:
			{
				return _extends({}, state, {
					loading: false,
					loaded: false,
					data: null,
					error: action.error
				});
			}
		default:
			{
				return state;
			}
	}
}

function isLoaded(globalState) {
	return globalState.navSpecialSeries && globalState.navSpecialSeries.loaded;
}

function load() {
	return {
		types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
		promise: function promise(client) {
			return client.get('/bbrew/v1/special-series');
		}
	};
}
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/navSpecialSeries.js
 ** module id = 265
 ** module chunks = 0
 **/